import * as React from 'react';
import { SVGProps } from 'react';

const RefundsIconSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M9.98 12.464h-6v-6'
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M23.778 8.222a11 11 0 0 0-15.556 0l-4.243 4.242M22.02 19.535h6v6'
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M8.222 23.778a11 11 0 0 0 15.556 0l4.243-4.242'
    />
  </svg>
);

export default RefundsIconSidebar;
